// Mirrors selfservice-api/src/auth/role-rank.ts + the legacy
// supabase/functions/create-auth-user/index.ts hierarchy. Used by the Team tab
// to gate the Remove button by caller rank.

export const ROLE_RANK: Record<string, number> = {
  super_admin: 4,
  organization_admin: 3,
  manager: 2,
  sales_rep: 1,
};

export function rankOf(role: string | null | undefined): number {
  if (!role) return 0;
  return ROLE_RANK[role] ?? 0;
}

export const ROLE_LABEL: Record<string, string> = {
  sales_rep: 'Station rep',
  manager: 'Manager',
  organization_admin: 'Org admin',
  super_admin: 'Super admin',
};
